<template lang="pug">
  .max-w-350.mx-auto.mx-lg-0
    h4.mb-2 Create An Account
    p.mb-4.px-3 Please complete and create your account. We’ll send you a link to set your password.

    .alert.alert-danger(v-if="hasError")
      font-awesome-icon(:icon="['fal', 'exclamation-circle']")
      |  {{ errorMessage }}

    el-form(
      :model="signUp"
      status-icon
      :rules="rules"
      ref="signUp"
      @submit.native.prevent="validateForm('signUp')"
    )
      .row.row-xs
        .col-md-6
          el-form-item(prop="firstName")
            el-input(v-model="signUp.firstName" placeholder="First Name*")

        .col-md-6
          el-form-item(prop="lastName")
            el-input(v-model="signUp.lastName" placeholder="Last Name*")

        .col-md-6
          el-form-item(prop="email")
            el-input(
              v-model="signUp.email"
              type="email"
              placeholder="Email"
              auto-complete="off"
              @blur="validateEmail"
            )

        .col-md-6
          el-form-item(prop="phone")
            el-input(
              v-model="signUp.phone"
              placeholder="Phone*"
              v-mask="'(###) ###-####'"
              type="tel"
            )

      .mb-4.mt-1.h-1.bg-dark
        // divider

      el-form-item(prop="companyName")
        el-input(v-model="signUp.companyName" placeholder="Company Name*")

      el-form-item(prop="companyAddress")
        el-input(v-model="signUp.companyAddress" placeholder="Company Address")

      .row.row-xs
        .col-md-5
          el-form-item(prop="city")
            el-input(v-model="signUp.city" placeholder="City")

        .col-md-3
          el-form-item(prop="state")
            el-input(v-model="signUp.state" placeholder="State")

        .col-md-4
          el-form-item(prop="zip")
            el-input(v-model="signUp.zip" placeholder="Zip Code")

      el-form-item
        el-button(
          type="primary",
          native-type="submit"
          v-loading.fullscreen.lock="loading"
        ).w-100 Create Account

      .mb-3
        span.fs-12.mr-2 Already have an account?
        router-link(to="/sign-in") Sign In

      p.fs-12 By signing up, you agree to our Terms of Use and Privacy Policy
</template>

<script>
import { mask } from 'vue-the-mask';
import { throwAwayDomains, disallowedDomains } from '@/data/emaildomains';
import { publicUserSignUp } from '@/models/user';
import authMixin from './AuthMixin';
// import cognito from '../../helpers/cognito';

export default {
  name: 'SignUp',
  directives: { mask },
  mixins: [authMixin],
  data() {
    const validateEmailDomains = (rule, value, callback) => {
      const domain = value.replace(/.*@/, '');
      const allowedDomains = ['yopmail.com', 'gmail.com'];
      if (allowedDomains.indexOf(domain) !== -1) {
        callback();
      }
      if (throwAwayDomains.indexOf(domain) === -1
          && disallowedDomains.indexOf(domain) === -1) {
        callback();
      } else {
        callback(new Error('A valid company domain is required'));
      }
    };

    const checkUniqEmail = (rule, value, callback) => {
      if (this.currentEmail !== value) {
        this.emailUniq = true;
      }
      if (!this.emailUniq) {
        callback(new Error('A user with the same email already exists'));
      }
      callback();
    };

    return {
      signUp: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        companyName: '',
        companyAddress: '',
        city: '',
        state: '',
        zip: '',
        ref: '',
      },
      hasError: false,
      errorMessage: '',
      loading: false,
      emailUniq: true,
      currentEmail: '',
      rules: {
        firstName: { required: true, message: 'First Name is required', trigger: 'blur' },
        lastName: { required: true, message: 'Last Name is required', trigger: 'blur' },
        email: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
          { validator: validateEmailDomains, trigger: 'blur' },
          { validator: checkUniqEmail, trigger: 'blur' },
        ],
        phone: { required: true, message: 'Phone is required', trigger: 'blur' },
        companyName: { required: true, message: 'Company Name is required', trigger: 'blur' },
      },
    };
  },

  mounted() {
    const { ref } = this.$route.query;
    if (ref) {
      this.signUp.ref = ref;
    }
  },

  methods: {
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          return this.submit();
        }
        return false;
      });
    },

    validateEmail() {
      // !!valid returns true/false;
      this.$refs.signUp.validateField('email', (valid) => !!valid);
    },

    submit() {
      this.loading = true;
      publicUserSignUp(this.signUp).then(() => {
        this.$router.push('/sign-in?from=signUp');
      }).catch((err) => {
        if (err.code === 'UsernameExistsException') {
          this.currentEmail = this.signUp.email;
          this.emailUniq = false;
          this.validateEmail();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
